import { Row, Col, Container } from "react-bootstrap";
import OwnerShopProfile from "../../components/OwnerShopProfile/OwnerShopProfile";
import ShopItemsOwner from "../../components/ShopItemsOwner/ShopItems";
import { useParams, useLocation } from "react-router-dom";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import { useState, useEffect } from "react";
import BackArrow from "../../components/backArrow";
import ShopManagebuttons from "../../components/Shops_manage_buttons";
import { useSelector } from "react-redux";
import {
  useGetShopByIdQuery,
  useLazyGetUserShopsByBusinessTypeQuery,
  useLazyGetShopSuggestionsByVendorIdQuery,
} from "../../features/shop/shopApiSlice";
import { extractIdFromSlug } from "../../utils/slugUtils";

const NewItembussinesProfile = () => {

  const [suggest, setSuggest] = useState(0);
  const [suggestdetail, setSuggestdetail] = useState(0);
  const [Report, Setreport] = useState(0);
  const [Reportdetail, SetReportdetail] = useState(0);
  const location = useLocation();
  const [suggestdata, setSuggestdata] = useState([]);
  const stateSetter = location.state && location.state.stateSetter;
  const { id: slugId } = useParams();
  const id = extractIdFromSlug(slugId);
  const { name } = useSelector((state) => state.user);

  const { data: shopRes } = useGetShopByIdQuery(id, {
    skip: !id,
    refetchOnMountOrArgChange: true,
  });
  const shopData = shopRes?.data?.Shop;

  const [triggerUserShops] = useLazyGetUserShopsByBusinessTypeQuery();
  const [triggerVendorSuggestions] = useLazyGetShopSuggestionsByVendorIdQuery();

  useEffect(() => {
    if (!name?._id) return;

    triggerUserShops({ userid: name._id, businessType: "retailerShop" })
      .unwrap()
      .then((res) => {
        const category = res?.data?.Shops?.[0]?.shopCategory?.name;
        if (category) {
          localStorage.setItem("mycategory", category);
        }
      })
      .catch((error) => {
        console.error("Failed to load user shop category", error);
      });
  }, [name?._id, triggerUserShops]);

  const updateState = () => {
    if (stateSetter) {
      stateSetter(1);
    }
  };

  const suggestdatta = async () => {
    const vendorid = shopData?._id;
    if (!vendorid) return;

    try {
      const response = await triggerVendorSuggestions(vendorid).unwrap();
      const allSuggestions = response?.data?.reduce((acc, curr) => {
        return [...acc, ...(curr?.suggestions || [])];
      }, []) || [];
      setSuggestdata(allSuggestions);
    } catch (error) {
      console.error("Failed to load suggestion data", error);
    }
  };


  return (
    <Container>
      <Col md={12} lg={11} className="mx-auto">
        <Row>
          <Col md={4} lg={3} className="p-0">
            <OwnerShopProfile
              shopid={id}
              Name="Update New Items Profile"
              navigateTo="/new-items-update"
              shopData={shopData}
              suggestdatta={suggestdatta}
              setSuggest={setSuggest}
              Setreport={Setreport}
              Reportdetail={Reportdetail}
              salespromotion="sales promotion"
              icon={<LocalOfferIcon className="silver-icon" />}
            />
          </Col>

          <Col md={8} lg={9} className=" screenHeight custom_ps-4">
            <div className="Form-Shadow h-100">
              <Row>
                <Col lg="4">
                  <BackArrow
                    back={`/rawmaterial-newitem/${id}`}
                    mystyle="ps-2 pt-1 d-none d-lg-block"
                  />
                </Col>
                <Col lg="8" className="mt-2 pe-4">
                  <ShopManagebuttons businessurl="/RetailerShop" shopid={id} />
                </Col>
              </Row>
              <ShopItemsOwner
                suggest={suggest}
                suggestdata={suggestdata}
                shopData={shopData}
                setSuggest={setSuggest}
                suggestdetail={suggestdetail}
                setSuggestdetail={setSuggestdetail}
                urlPass="/new-item-owner-view"
                shopid={id}
                post={`/newitems-Postadd/${id}`}
                navigateto="/new-items-form"
                updateState={updateState}
                Setreport={Setreport}
                Report={Report}
                SetReportdetail={SetReportdetail}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Container>
  );
};

export default NewItembussinesProfile;
